<div class="row">
  <div class="col-xs-8 col-md-10">
    <page-title [title]="titleMedications" class="horario subtitle"></page-title>
  </div>
  <div class="col-xs-4 col-md-2 btAdd">
    <button mat-stroked-button color="primary" (click)="addPrescription()">
      <mat-icon>add</mat-icon>
    </button>
  </div>
</div>

<page-alert [message]="messageSuccess" *ngIf="showSuccessMessage" alertClass="alert-success"></page-alert>
<page-alert [message]="messageError" *ngIf="showErrorMessage" alertClass="alert-danger"></page-alert>
<div *ngFor="let medication of medications">
  <mat-card>
    <div class="col-xs-6 col-md-6">
      <mat-form-field class="cards" appearance="outline">
        <mat-label>Nome da medicação</mat-label>
        <input type="text" matInput (ngModelChange)="onChangeForm()" [(ngModel)]="medication.medicationName" placeholder="Nome" />
      </mat-form-field>
    </div>
    <div class="col-xs-6 col-md-6">
      <mat-form-field class="cards" appearance="outline">
        <mat-label>Tipo da medicação</mat-label>
        <input type="text" matInput (ngModelChange)="onChangeForm()" [(ngModel)]="medication.medicationType" placeholder="Comprimido, gotas, etc..." />
      </mat-form-field>
    </div>
    <div class="col-xs-6 col-md-6">
      <mat-form-field class="cards" appearance="outline">
        <mat-label>Dosagem</mat-label>
        <input type="text" matInput (ngModelChange)="onChangeForm()" [(ngModel)]="medication.dosage" placeholder="Número de gotas, quantidade de comprimidos, etc..." />
      </mat-form-field>
    </div>
    <div class="col-xs-6 col-md-6">
      <mat-form-field class="cards" appearance="outline">
        <mat-label>Uso</mat-label>
        <input type="text" matInput (ngModelChange)="onChangeForm()" [(ngModel)]="medication.use" placeholder="Uso da medicação(manhã, após o café, etc...)" />
      </mat-form-field>
    </div>
    <div class="col-xs-6 col-md-6">
      <mat-form-field class="cards" appearance="outline">
        <mat-label>Recomendação</mat-label>
        <input type="text" matInput (ngModelChange)="onChangeForm()" [(ngModel)]="medication.recommendation" placeholder="Recomendações acerta da medicação" />
      </mat-form-field>
    </div>
  </mat-card>
</div>

<div class="row">
  <div class="col-xs-12 actions">
    <button *ngIf="mode == 'UPDATE'" (click)="save()" mat-flat-button color="primary">Salvar alterações</button>
    <button *ngIf="mode == 'CREATE'" (click)="create()" mat-flat-button color="primary">Criar Receita</button>
  </div>
</div>
